import React, { ReactElement, useEffect } from 'react';

import { TransitionGroup } from 'react-transition-group';
import CardFormWL from './cardForm/CardFormWL';
import SavedInstrumentsList from './savedInstruments/SavedInstrumentsList';
import ExpandableContent from './savedInstruments/expandableContent/ExpandableContent';
import { AnimationType } from './savedInstruments/expandableContent/ExpandableContent.types';
import withCardContext from '../../../hoc/withCardContext';
import { ICardWLProps } from './CardWL.types';

function CardWL(props: ICardWLProps): ReactElement {
  const {
    shouldShowCardForm,
    setShouldShowCardForm,
    setIsCardComponentLoading,
    savedInstruments,
    isSavedInstrumentLoaded,
    isCardComponentLoading,
  } = props;

  useEffect(() => {
    if (isSavedInstrumentLoaded && savedInstruments.length === 0 && !isCardComponentLoading) {
      setShouldShowCardForm(true);
    }
  }, [savedInstruments]);

  useEffect(() => {
    if (!shouldShowCardForm) {
      setIsCardComponentLoading(false);
    }
  }, []);

  const handleCardInputDataClick = () => {
    const { setTokenizedPayment } = props;
    setIsCardComponentLoading(true);
    setShouldShowCardForm(true);
    setTokenizedPayment(false);
  };

  const handleShowSavedInstrumentClick = () => {
    const { setTokenizedPayment } = props;
    setIsCardComponentLoading(true);
    setShouldShowCardForm(false);
    setTokenizedPayment(true);
  };

  return (
    <TransitionGroup>
      <ExpandableContent expanded={shouldShowCardForm} type={AnimationType.Opacity}>
        <CardFormWL
          {...props}
          hasSavedInstruments={(savedInstruments && savedInstruments.length > 0) || false}
          handleShowSavedInstrumentClick={handleShowSavedInstrumentClick}
        />
      </ExpandableContent>
      <ExpandableContent expanded={!shouldShowCardForm} type={AnimationType.Opacity}>
        <SavedInstrumentsList
          {...props}
          isVisible={!shouldShowCardForm}
          handleClickInputCardData={handleCardInputDataClick}
        />
      </ExpandableContent>
    </TransitionGroup>
  );
}

export default withCardContext(CardWL);
